/**
 * WordPress dependencies
 */
import { store, getContext } from "@wordpress/interactivity";
import { getStoreDetails } from "../js/utils";

const { state } = store("cc-lvlgroup-marketing-store-list", {
  state: {
    previousSelectedId: -2,
    src: "",
    srcset: "",
    sizes: "",
    alt: "",
    content: "",
    isLoading: false,
    hasContent: false,
  },
  callbacks: {
    setStoreDetails: function* () {
      if (
        !state.isSmallDisplay() &&
        state.previousSelectedId !== state.shopSelectedId
      ) {
        state.isLoading = true;
        try {
          const storePost = yield getStoreDetails(state.shopSelectedId);

          const div = document.getElementById("store-content");
          if (div) {
            div.innerHTML = storePost.content;
          }

          state.hasContent = !storePost.isThumbnail;

          state.previousSelectedId = state.shopSelectedId;
        } finally {
          state.isLoading = false;
        }
      }
    },
  },
});
